import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Grid } from '@mui/material'

// SERVICES
import { getDashboardByDriverId } from '../../../../services/dashboard/getDatosDashboard';

// ICONOS
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

// COMPONENTES
import MiTabla from '../../../../components/plantilla/tabla/MiTabla';

const ModalDrivers = ({ open, onClose, driver }) => {

    const columns = [

        { 
            field: 'event_type',
            headerName: 'Event',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'vehicle', 
            headerName: 'Truck',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'driver', 
            headerName: 'Driver',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'reason', 
            headerName: 'Reason',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'severity', 
            headerName: 'Severity',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'event_date', 
            headerName: 'Event Date',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'end_date', 
            headerName: 'Event Ended',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'tiempo_atencion', 
            headerName: 'Response Time',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'incident_url', 
            headerName: 'Samsara URL',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => 
                <Button
                    variant="contained"
                    color="primary"
                    target='_blank'
                    href={params.row.incident_url}
                >
                    <GpsFixedIcon />
                </Button>
        },

    ];

    const [events, setEvents] = useState([]);

    const fetchData = async () => {

        const data = await getDashboardByDriverId(driver);

        setEvents(data);

    }

    useEffect(() => {

        fetchData();

    }, [driver]);

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                {driver}
            </DialogTitle>

            {/* BODY */}

            <DialogContent sx={{ width: '100%' }}>

                <Grid container spacing={2} marginTop={1}>

                    <Button onClick={onClose} startIcon={<ArrowBackIcon />}>
                        Back
                    </Button>

                    {/* TABLA */}
                    <Grid size={12}>

                        <MiTabla
                            columns={columns}
                            data={events}
                        />
                        
                    </Grid>

            </Grid>

            </DialogContent>

        </Dialog>

    )

}

export default ModalDrivers